import { useState, useRef, useCallback } from 'react';

const useHorizontalDrag = () => {
    const wrapRef = useRef(null);
    // 用來記錄滑鼠按下時的初始資訊，避免 Re-render 導致資料遺失
    const coords = useRef({ left: 0, x: 0, isDown: false });
    const [isDragging, setIsDragging] = useState(false);

    const mouseMoveHandler = useCallback((e) => {
        if (!coords.current.isDown || !wrapRef.current) return;

        const dx = e.clientX - coords.current.x;

        // 如果位移超過一定像素才判定為拖拽，避免微小抖動導致點擊失效
        if (Math.abs(dx) > 5) {
            setIsDragging(true);
        }

        wrapRef.current.scrollLeft = coords.current.left - dx;
    }, []);

    const mouseUpHandler = useCallback(() => {
        coords.current.isDown = false;

        // 延遲重置拖拽狀態，確保點擊事件判斷正確
        setTimeout(() => {
            setIsDragging(false);
        }, 0);

        window.removeEventListener('mousemove', mouseMoveHandler);
        window.removeEventListener('mouseup', mouseUpHandler);
    }, [mouseMoveHandler]);

    const mouseDownHandler = (e) => {
        // 排除右鍵與中鍵
        if (!wrapRef.current || e.button !== 0) return;

        coords.current = {
            left: wrapRef.current.scrollLeft,
            x: e.clientX,
            isDown: true,
        };

        window.addEventListener('mousemove', mouseMoveHandler);
        window.addEventListener('mouseup', mouseUpHandler);
    };

    return {
        wrapRef,
        mouseDownHandler,
        isDragging,
    };
};

export default useHorizontalDrag;
